import { BaseWithId, BaseModel } from './base';
import { PaginatedResponse } from './pagination';

export enum ResponseStatus {
    FAIL = 'FAIL',
    ERROR = 'ERROR',
    SUCCESS = 'SUCCESS'
}

export interface DRResponseMeta {
    status: ResponseStatus;
    message: string;
    additional_code: string;
    additional_data: any;
}

export interface DRResponse<T extends any> extends DRResponseMeta {
    data: T;
}

export class ResponseColumn extends BaseModel {
    public id: string;
    public label: string;
    public sortable: boolean;
    public type: string;
    public field: string;
    public cellRenderer: any;
    public cellClass: any;
    public headerClass: any;
    public headerName: any;
    public childColumns: any;
    public minWidth: any;
    public maxWidth: any;
    public checkboxSelection: boolean;
    public headerComponentParams: any;
    public rowDrag: boolean;
    public resizable: boolean;
    public width: number;

    constructor(json?: any) {
        super(json);
    }
}


export class ResponseRow extends BaseWithId {
    public highlights: any;
    public values: [];

    constructor(json?: any) {
        super(json);
    }

    protected setObjectMappings(json: any): any {
        return Object.assign(super.setObjectMappings(json), {
            values: json.values ? json.values.map((jsonValue: any) => jsonValue) : []
        });
    }
}


export class SearchResponse extends BaseModel implements PaginatedResponse {
    public from: number;
    public limit: number;
    public row_count: number;

    public order: string;
    public desc: boolean;

    public columns: ResponseColumn[];
    public rows: ResponseRow[];

    constructor(json?: any) {
        super(json);
    }

    protected setObjectMappings(json: any): any {
        return Object.assign(super.setObjectMappings(json), {
            columns: json && json.columns ? json.columns.map((jsonValue: any) => new ResponseColumn(jsonValue)) : [],
            rows: json && json.rows ? json.rows.map((jsonValue: any) => new ResponseRow(jsonValue)) : []
        });
    }
}
